import config from '../config';

export default function getRepositoryContributors(repositoryId) {
    return fetch(`${config.github.apiBaseURL}/repos/${repositoryId}/contributors?per_page=1&anon=true`);
}